import { Link } from 'react-router-dom';
import Seo, { SEO, SITE_URL } from '../components/Seo';
import JsonLd from '../components/JsonLd';
import { BLOG_POSTS } from '../data/blogPosts';
import { LIVE_TOOLS } from '../data/tools';

export default function Blog() {
  const sorted = [...BLOG_POSTS].sort((a, b) => b.date.localeCompare(a.date));

  return (
    <>
      <Seo {...SEO.blog} />
      <JsonLd
        data={{
          '@context': 'https://schema.org',
          '@type': 'Blog',
          name: 'PixelUtility Blog',
          url: `${SITE_URL}/blog`,
          description: SEO.blog.description,
          blogPost: sorted.map((post) => ({
            '@type': 'BlogPosting',
            headline: post.title,
            url: `${SITE_URL}/blog/${post.slug}`,
            datePublished: post.date,
            description: post.excerpt,
          })),
        }}
      />
      <div className="pt-24 pb-20 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-extrabold text-gray-900">PixelUtility Blog</h1>
          <p className="mt-4 text-lg text-gray-600">
            In-depth guides that support our free tools — resumes, QR codes, and size conversion.
          </p>
          <div className="mt-12 space-y-8">
            {sorted.map((post) => {
              const tool = LIVE_TOOLS.find((t) => t.id === post.relatedTool);
              return (
                <article key={post.slug} className="border-b border-gray-100 pb-8">
                  <span className="text-xs font-medium text-brand-600">{post.category}</span>
                  <h2 className="mt-2 text-2xl font-bold text-gray-900">
                    <Link to={`/blog/${post.slug}`} className="hover:text-brand-600">
                      {post.title}
                    </Link>
                  </h2>
                  <p className="mt-2 text-gray-600">{post.excerpt}</p>
                  <div className="mt-4 flex flex-wrap gap-4 text-sm">
                    <time className="text-gray-400" dateTime={post.date}>
                      {new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                    </time>
                    {tool && (
                      <Link to={tool.landingPath} className="text-brand-600 hover:underline">
                        Related: {tool.name}
                      </Link>
                    )}
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
